"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _configuratorCarousel = require("@mmc/configurator-carousel");
var _configuratorFabricSelector = require("@mmc/configurator-fabric-selector");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _disclaimer = _interopRequireDefault(require("./disclaimer/disclaimer"));
var _configurator = _interopRequireDefault(require("../styles/configurator.css"));
var _actions = require("../actions");
var dataUtils = new _mmcDataUtilities["default"]();
var isEmptyArray = dataUtils.isEmptyArray;
var FabricSelector = /*#__PURE__*/function (_React$Component) {
  function FabricSelector(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.changeEvent = _this.changeEvent.bind(_this);
    return _this;
  }
  (0, _inheritsLoose2["default"])(FabricSelector, _React$Component);
  var _proto = FabricSelector.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
      fabric = _this$props.fabric,
      preferences = _this$props.preferences,
      updateSelections = _this$props.updateSelections,
      data = _this$props.data;
    var filter = data.filter || {};
    var filteringOptions = filter.filteringOptions || [];
    var dispatch = this.props.dispatch;
    var selectedFabricCode = fabric;
    var preSelectedFabric = filteringOptions.find(function (currentFabric) {
      return currentFabric.selected === true;
    });

    // Check if currently configured fabric is available
    if (!this.checkFabricIsValid(selectedFabricCode)) {
      // Use preference if it is valid
      if (this.checkFabricIsValid(preferences.fabric)) {
        selectedFabricCode = preferences.fabric;
        // Use hero colour if it was supplied
      } else if (preSelectedFabric) {
        if (preSelectedFabric.code) {
          selectedFabricCode = preSelectedFabric.code;
        }
        // Use first option
      } else if (filteringOptions) {
        if (filteringOptions[0]) {
          selectedFabricCode = filteringOptions[0].code;
        }
      }
      dispatch((0, _actions.setFabric)(selectedFabricCode));
    }

    // Set our app configuration to match
    updateSelections({
      fabric: selectedFabricCode
    });
  };
  _proto.checkFabricIsValid = function checkFabricIsValid(fabric) {
    var isValid = false;
    var data = this.props.data;
    var filter = data.filter || {};
    var filteringOptions = filter.filteringOptions || [];
    if (fabric !== '' && fabric !== undefined && fabric !== null) {
      if (filteringOptions.find(function (currentFabric) {
        return currentFabric.code === fabric;
      })) {
        isValid = true;
      }
    }
    return isValid;
  };
  _proto.changeEvent = function changeEvent(e) {
    var dispatch = this.props.dispatch;
    dispatch((0, _actions.setFabric)(e.target.value));
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      fabric = _this$props2.fabric,
      minorQueryPending = _this$props2.minorQueryPending,
      market = _this$props2.market,
      data = _this$props2.data,
      _this$props2$theme = _this$props2.theme,
      theme = _this$props2$theme === void 0 ? {} : _this$props2$theme,
      direction = _this$props2.direction;
    var filter = data.filter,
      headingText = data.headingText;
    var carousel = data.carousel || {};
    var fabricSelectorData = {
      filter: filter,
      headingText: headingText
    };
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['container-fluid'] + " " + _configurator["default"].stepContent
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + theme.row
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-sm-6']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row + " " + _configurator["default"].loaderWrapper
    }, !isEmptyArray(carousel.items) && /*#__PURE__*/_react["default"].createElement(_configuratorCarousel.ConfiguratorCarousel, {
      theme: theme,
      data: carousel,
      isLoading: minorQueryPending > 0,
      isLowControls: true
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-sm-6'] + " " + theme.marginBottom40,
      dir: direction
    }, /*#__PURE__*/_react["default"].createElement(_configuratorFabricSelector.ConfiguratorFabricSelector, {
      theme: theme,
      data: fabricSelectorData,
      changeEvent: this.changeEvent,
      selectedCard: fabric
    }), data.disclaimer && market !== 'us' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", {
      className: theme.smallType + " " + _configurator["default"].stepDisclaimer
    }, data.disclaimer))), data.disclaimer && market === 'us' && /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-md-offset-1'] + " " + theme['col-md-10']
    }, /*#__PURE__*/_react["default"].createElement(_disclaimer["default"], {
      theme: theme,
      headline: "Disclaimer",
      content: data.disclaimer
    }))));
  };
  return FabricSelector;
}(_react["default"].Component);
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    fabric: state.fabric.value,
    theme: props.theme,
    preferences: props.preferences,
    data: props.data,
    updateSelections: props.updateSelections,
    minorQueryPending: props.minorQueryPending
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(FabricSelector);